import React from 'react'

const Configurable = ({ color }) => {
    return (
        <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8 1.66634H1.33333V12.333H10.6667V4.33301H8V1.66634ZM0 0.994341C0 0.629008 0.298 0.333008 0.666 0.333008H8.66667L12 3.66634V12.995C12.0006 13.0826 11.984 13.1694 11.951 13.2505C11.9181 13.3316 11.8695 13.4054 11.808 13.4678C11.7466 13.5301 11.6734 13.5797 11.5928 13.6138C11.5121 13.6479 11.4255 13.6657 11.338 13.6663H0.662C0.486919 13.6651 0.319345 13.5951 0.195478 13.4713C0.0716119 13.3476 0.00139643 13.1801 0 13.005V0.994341ZM9.77133 6.99967L7.414 9.35701L6.47133 8.41368L7.88533 6.99967L6.472 5.58567L7.414 4.64234L9.77133 6.99967ZM2.22867 6.99967L4.58667 4.64234L5.52933 5.58567L4.11467 6.99967L5.528 8.41368L4.586 9.35701L2.22867 6.99967Z" fill={color ? color : "#2D3748"} />
        </svg>
    )
}

export default Configurable